import { GET_RESE_BMS_TABLE_DATA, GET_RESE_BMS_TABLE_DANFOSS_VERSION_FIRMWARE, GET_RESE_BMS_TABLE_EMERSON_VERSION_FIRMWARE,
GET_RESE_BMS_TABLE_STATUS, UPDATE_RESE_BMS_TABLE_DATA } from "./actionTypes";

const initialState = {
    reseBmsTableData: [],
    reseBmstableDataErrorMessage: null,
    reseBmsTableDanfossVersionsAndFirmware: [],
    reseBmsTableEmersonVersionsAndFirmware: [],
    reseBmsTableStatus: [],
    totalRecords: 0,
    updateSuccess: false,
    updateError: null
}

const reseBmsReducer = (state=initialState, action={type: "", payload:null}) => {
    switch(action.type) {
        case GET_RESE_BMS_TABLE_DATA.SUCCESS:
            let { bmsDataList, totalRecords } = action.payload;
            return {
                ...state,
                reseBmsTableData: bmsDataList,
                totalRecords: totalRecords,
                updateSuccess: false,
                updateError: null
            }
        
        case GET_RESE_BMS_TABLE_DATA.ERROR:
            return {
                ...state,
                reseBmstableDataErrorMessage:action.payload
            }

        case UPDATE_RESE_BMS_TABLE_DATA.SUCCESS:
            return {
                    ...state,
                    updateSuccess: true,
                    updateError: null
                }   
    
        case UPDATE_RESE_BMS_TABLE_DATA.ERROR:
            return {
                        ...state,
                        updateSuccess: false,
                        updateError: action.payload
                    }

        case GET_RESE_BMS_TABLE_DANFOSS_VERSION_FIRMWARE.SUCCESS:
            return {
                ...state,
                reseBmsTableDanfossVersionsAndFirmware: action.payload
            }

        case GET_RESE_BMS_TABLE_EMERSON_VERSION_FIRMWARE.SUCCESS:
            return {
                ...state,
                reseBmsTableEmersonVersionsAndFirmware: action.payload
            }

        case GET_RESE_BMS_TABLE_STATUS.SUCCESS:
            return {
                ...state,
                reseBmsTableStatus: action.payload
            }
        default:
            return state
    }
}

export default reseBmsReducer;